import { CognitoUserPool, CookieStorage } from "amazon-cognito-identity-js";

const validateUserSession = () => {
  const poolData = {
    UserPoolId: window?._env_?.COGNITO_AUTH_POOL_ID || "eu-west-1_UserPoolId",
    ClientId: window?._env_?.COGNITO_AUTH_CLIENT_ID || "ClientId",
    Storage: new CookieStorage({
      secure: process.env.COOKIE_SECURE,
      domain: window?._env_?.COOKIE_DOMAIN || "localhost",
    }),
  };
  const userPool = new CognitoUserPool(poolData);
  const cognitoUser = userPool.getCurrentUser();

  if (!cognitoUser) {
    window.location = window?._env_?.AUTHENTICATION_REDIRECT_URL;
  }

  if (cognitoUser != null) {
    cognitoUser.getSession(function (err, session) {
      if (err) {
        window.location = window?._env_?.AUTHENTICATION_REDIRECT_URL;
      }
    });
  }
};

export default validateUserSession;
